import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export enum PaymentStatus {
	NO_CONFIRMED = 0,
	PENDING = 1,
	ACCEPTED = 2,
	REJECTED = 3,
	EXIST = 4,
	AWAITINGAPPROVAL = 5,
	FAILURE = 6,
	NOTFOUND = 7,
	CANCELED = 8,
	Refund = 9,
	COMPLETED = 10,
	Incomplete = 11
}

export namespace PaymentStatus {

	export function getTitle(type: PaymentStatus): string {
		return Object.keys(PaymentStatus).find(key => PaymentStatus[key] === type);
	}

}

@Pipe({
	name: 'paymentStatusText',
	standalone: true
})


export class PaymentStatusTextPipe implements PipeTransform {

	paymentStatus = PaymentStatus;
	translatedText: string;


	constructor(private translateService: TranslateService) {
	}

	transform(value: PaymentStatus): any {
		this.getTranslate(
			this.paymentStatus.getTitle(value)
		);
		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.PAYMENT_STATUS.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}

@Pipe({
	name: 'directDepositpaymentStatusText',
	standalone: true
})


export class DirectDepositPaymentStatusTextPipe implements PipeTransform {

	paymentStatus = PaymentStatus;
	translatedText: string;


	constructor(private translateService: TranslateService) {
	}

	transform(value: PaymentStatus): any {
		this.getTranslate(
			this.paymentStatus.getTitle(value)
		);
		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.DIRECT_DEPOSIT_PAYMENT_STATUS.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}


